import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getMyBookmarks } from "../slices/4-bookmark/thunk";
import PostsBase from "../component/sharedComponents/PostsBase";
import { useNavigate } from "react-router-dom";
import { BookmarkIcon } from "lucide-react";
import MainButton from "../component/sharedComponents/MainButton";
import { useTranslation } from "react-i18next";
import SectionLoader from "../component/sharedComponents/Loading/SectionLoader";

const SavedPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { bookmarks, pagination, loading } = useSelector((state) => state.bookmark);
    const { t } = useTranslation();

    const [isFetchingMore, setIsFetchingMore] = useState(false);

    const paginationRef = useRef(pagination);
    // keep ref updated
    useEffect(() => {
        paginationRef.current = pagination;
    }, [pagination]);

    useEffect(() => {
        dispatch(getMyBookmarks({ limit: 10, page: 1 }));
    }, [dispatch]);
    // console.log(bookmarks)
    useEffect(() => {
        const handleScroll = () => {
            const { hasNextPage, nextPage } = paginationRef.current || {};
            if (!hasNextPage || isFetchingMore) return;

            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const docHeight = document.documentElement.scrollHeight;

            if (scrollTop + windowHeight >= docHeight * 0.9) {
                setIsFetchingMore(true);

                dispatch(
                    getMyBookmarks({
                        limit: 10,
                        page: nextPage,
                    })
                ).finally(() => {
                    setIsFetchingMore(false);
                });
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [dispatch, isFetchingMore]);

    if (loading && bookmarks.length === 0) {
        return <SectionLoader />;
    }
    if (bookmarks?.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center max-w-2xl mx-auto space-y-4 text-center text-gray-300">
                <div
                    className="w-full px-4 py-6 space-y-4 overflow-hidden text-center duration-300 border bg-bg-light-secondary border-border-light rounded-xl dark:bg-bg-dark-secondary dark:border-border-dark"
                >

                    <BookmarkIcon className="w-16 h-16 text-[#80B39D] mx-auto" />

                    <h2 className="text-xl font-semibold text-black dark:text-white">{t("bookmarks.noBookmarksYet")}</h2>
                    <p className="text-gray-400 ">
                        {t("bookmarks.description")}
                    </p>
                    <MainButton
                        onClick={() => navigate("/")}
                    >
                        {t("bookmarks.browseFeed")}
                    </MainButton>
                </div>
            </div>
        );
    }

    return (
        <>
            <PostsBase posts={bookmarks} />
            {isFetchingMore && <SectionLoader />}
        </>
    )
};

export default SavedPage;
